var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 101,
    viewBox: "0 0 90 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_549_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0069 0.00402832H0.000854492V100.411H90.0069V0.00402832Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_549_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3248 69.2101V94.91C38.3248 97.95 35.8609 100.41 32.8227 100.41H5.51003C2.47181 100.41 0.0078125 97.95 0.0078125 94.91V69.2101C0.0078125 66.1801 2.47181 63.7101 5.51003 63.7101H32.8227C35.8609 63.7101 38.3248 66.1801 38.3248 69.2101Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0029 5.51001V31.21C90.0029 34.25 87.539 36.71 84.5008 36.71H57.1881C54.1499 36.71 51.6859 34.25 51.6859 31.21V5.51001C51.6859 2.48001 54.1499 0.0100098 57.1881 0.0100098H84.5008C87.539 0.0100098 90.0029 2.48001 90.0029 5.51001Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3248 5.75287V46.3525C38.3248 49.5324 35.7461 52.1017 32.5721 52.1017H5.76059C2.58665 52.1017 0.0078125 49.5324 0.0078125 46.3525V5.75287C0.0078125 2.57303 2.58665 0.00354004 5.76059 0.00354004H32.5721C35.7461 0.00354004 38.3248 2.57303 38.3248 5.75287Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0029 54.0628V94.6625C90.0029 97.8423 87.4345 100.412 84.2605 100.412H57.4282C54.2543 100.412 51.6859 97.8423 51.6859 94.6625V54.0628C51.6859 50.883 54.2543 48.3135 57.4282 48.3135H84.2605C87.4345 48.3135 90.0029 50.883 90.0029 54.0628Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverview);
export default __webpack_public_path__ + "static/media/icon_overview.ea5966e6cac093124002d940bb485839.svg";
export { ForwardRef as ReactComponent };